module.exports = __webpack_public_path__ + "img/save2xls.80a2ebb6.svg";